import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "submit", "error"]

  connect() {
    this.openListener = () => this.open()
    document.addEventListener("startup-name-prompt:open", this.openListener)
  }

  disconnect() {
    document.removeEventListener("startup-name-prompt:open", this.openListener)
  }

  open() {
    this.element.classList.remove("hidden")
    this.element.classList.add("flex")
    setTimeout(() => this.inputTarget.focus(), 50)
  }

  dismiss() {
    this.element.classList.add("hidden")
    this.element.classList.remove("flex")
    this.errorTarget.classList.add("hidden")
    this.errorTarget.textContent = ""
  }

  async submit(event) {
    event.preventDefault()

    const name = this.inputTarget.value.trim()
    if (!name) return

    this.errorTarget.classList.add("hidden")
    this.submitTarget.disabled = true
    this.submitTarget.classList.add("opacity-50", "pointer-events-none")

    const token = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
    const formData = new FormData()
    formData.append("name", name)

    try {
      const response = await fetch("/startups/quick_create", {
        method: "POST",
        headers: {
          "X-CSRF-Token": token,
          "Accept": "application/json"
        },
        body: formData
      })
      const data = await response.json()

      if (!response.ok || data.status !== "success") {
        this.showError((data.errors || ["Could not save startup."]).join(", "))
        return
      }

      this.dismiss()
    } catch (err) {
      this.showError("Network error — please try again.")
    } finally {
      this.submitTarget.disabled = false
      this.submitTarget.classList.remove("opacity-50", "pointer-events-none")
    }
  }

  showError(message) {
    this.errorTarget.textContent = message
    this.errorTarget.classList.remove("hidden")
  }
}
